import { Landmark, Scale, ShieldCheck } from "lucide-react";
import { Reveal, Eyebrow } from "../components/Reveal";

const SERVICES = [
  {
    icon: Landmark,
    title: "Living Trust Setup",
    text: "We set up a legally binding living trust that protects your home, savings, and assets from probate, lawsuits, and anything life throws at your family. You see everything first. You only move forward when you are satisfied.",
  },
  {
    icon: Scale,
    title: "Military Legal Review",
    text: "Through my veteran benefits every file receives a legal review by a licensed attorney at no additional charge. Your trust is not just a document. It is reviewed and validated. Available based on your location. Built into every file we take on.",
  },
  {
    icon: ShieldCheck,
    title: "Asset Protection Structure",
    text: "Beyond the trust we help you structure your assets so creditors, courts, and outside threats cannot reach what you have built. Own nothing. Control everything. The same structure wealthy families have used for generations.",
  },
];

export const WhatWeDo = () => (
  <section className="bg-ink py-24 sm:py-36 relative overflow-hidden" data-testid="what-we-do-section">
    <div className="absolute top-0 left-1/3 w-[600px] h-[400px] bg-gold/5 blur-[120px] rounded-full" aria-hidden="true" />
    <div className="max-w-7xl mx-auto px-5 sm:px-8 relative">
      <Reveal>
        <Eyebrow>What We Do</Eyebrow>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-cream tracking-tight leading-[1.06] mt-6">
          One Portal. <em className="text-gold italic">Complete Protection.</em>
        </h2>
      </Reveal>
      <div className="grid md:grid-cols-3 gap-6 mt-14 sm:mt-20">
        {SERVICES.map(({ icon: Icon, title, text }, i) => (
          <Reveal key={title} delay={0.12 * i} className="h-full">
            <div
              className="group h-full bg-surface border border-white/8 rounded-2xl p-8 sm:p-10 hover:border-gold/40 hover:-translate-y-1.5 transition-[border-color,transform] duration-500"
              data-testid={`service-card-${i}`}
            >
              <div className="w-14 h-14 rounded-full bg-gold/10 border border-gold/25 flex items-center justify-center text-gold group-hover:bg-gold group-hover:text-ink transition-colors duration-500">
                <Icon size={24} strokeWidth={1.8} />
              </div>
              <h3 className="font-display text-2xl text-cream mt-8">{title}</h3>
              <p className="text-cream/65 leading-relaxed mt-4 text-sm sm:text-base">{text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
